// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"dbf000a9","453":"ce2fd55d","732":"96ec1de7","977":"c4029ea1"}[chunkId] + ".chunk.js";
};